import { MiniKitProvider } from '@coinbase/onchainkit/minikit';
import { base } from 'viem/chains';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ background: 'transparent' }}>
      <MiniKitProvider chain={base}>{children}</MiniKitProvider>
    </div>
  );
}
